/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Karol Pawlak <karolpawlak.giap@gmail.com>, January 2020
 */

/* eslint-disable max-len */
/* flow-disable */

import React, { PropTypes } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import GrayPanel from '../../components/GrayPanel/GrayPanel';
import { connect } from 'react-redux';
import { runService } from '../../actions/eservices';
import PowrotDoListyEuslug from '../../components/PowrotDoListyEuslug/PowrotDoListyEuslug';
import EmptyFileDownloader from '../../components/EmptyFileDownloader/EmptyFileDownloader';
import { PersonalDataContainer } from '../../containers';
import CustomizedMap from './CustomizedMap';
import history from '../../core/history';
import pans from './panStyle.scss';
import ModalAlert from './ModalAlert';
import { DecisionContainer } from '../../containers';
import _ from 'lodash';

import v from './validators';
import fetch from '../../core/fetch/fetch.server';


const btnStyle = {
  borderRadius: 0,
  border: 'none',
  padding: '10px 40px',
  marginLeft: '10px',
};

const buildingTypeOptions = [
  {
    label: 'mieszkalny',
    value: 'mieszkalnego',
    state: 'buildingType',
  },
  {
    label: 'użytkowy',
    value: 'użytkowego',
    state: 'buildingType',
  },
  {
    label: 'garaż',
    value: 'garażu',
    state: 'buildingType',
  },
];

const lawBasicOptions = [
  {
    label: 'umowa sprzedaży',
    value: 'umowy sprzedaży',
    state: 'lawBasic',
  },
  {
    label: 'darowizna',
    value: 'darowizny',
    state: 'lawBasic',
  },
  {
    label: 'zamiana',
    value: 'zamiany',
    state: 'lawBasic',
  },
  {
    label: 'dziedziczenie',
    value: 'dziedziczenia na podstawie postanowienia Sądu',
    state: 'lawBasic',
  },
];

const InfoTypeDict = {
  parents: {
    label: 'Imiona rodziców:',
    editable: true,
  },
  pesel: {
    label: 'PESEL:',
    editable: true,
  },
  town: {
    label: 'Miejscowość położenia działki:',
    editable: true,
  },
  decisionNumber: {
    label: 'Nr księgi wieczystej:',
    editable: true,
  },
  buildingNr: {
    label: 'Numer nieruchomości lokalowej:',
    editable: true,
  },
  percent: {
    label: 'Udział w prawie użytkowania [%]:',
    editable: true,
  },
  buildingType: {
    label: 'Rodzaj lokalu:',
    editable: true,
    type: 'Select',
    options: buildingTypeOptions,
  },
  sellingDate: {
    label: 'Data umowy sprzedaży lokalu i użytkowania wieczystego:',
    editable: true,
  },
  lawBasic: {
    label: 'Przysługujące prawa nabyte zostały w wyniku:',
    editable: true,
    type: 'Select',
    options: lawBasicOptions,
  },
  lawDate: {
    label: 'Data nabycia praw:',
    editable: true,
  },
};

const courtTypeDict = {
  courtName: {
    label: 'Nazwa sądu:',
    editable: true,
  },
  courtNr: {
    label: 'Sygnatura akt:',
    editable: true,
  },
};


class PrzeksztalceniePrawaUzytkowania extends React.Component {
  state = {
    info: {
      parents: null,
      pesel: null,
      town: null,
      decisionNumber: null,
      buildingNr: null,
      percent: null,
      buildingType: null,
      sellingDate: null,
      lawBasic: null,
      courtName: null,
      lawDate: null,
      courtNr: null,
    },
    errors: {},
    errorTitle: '',
    errorText: '',
    showError: false,
    eserviceDistrict: null,
    selectedParcels: [],
  };

  validators = {
    parents: [v.NotNull],
    pesel: [v.NotNull],
    town: [v.NotNull],
    decisionNumber: [v.NotNull],
    buildingNr: [v.NotNull],
    percent: [v.NotNull, v.isNumber],
    buildingType: [v.NotSelected],
    sellingDate: [v.NotNull, v.CheckDate],
    lawBasic: [v.NotSelected],
    lawDate: [v.NotNull, v.CheckDate]
  };

  nextStep = '/eservices/eserviceSummary/';

  componentWillMount() {
    fetch(`${process.env.API_URL}/eservice/${this.props.district}/${this.props.query.serviceType}`)
      .then(r => r.json())
      .then(resp => {
        this.setState({
          eserviceDistrict: resp,
        });
      });
  }

  componentDidMount() {
    if (this.state.info.lawBasic === 'dziedziczenia') {
      this.validators.courtName = [v.NotNull];
      this.validators.courtNr = [v.NotNull];
    } else {
      this.validators.courtName = [];
      this.validators.courtNr = [];
    }
  }

  onHide = () => this.setState({ showError: false });

  setParcels = (parcels, callback = null) => this.setState({ selectedParcels: parcels });

  onChange = (e, group) => {
    const name = e.target.name;
    this.setState(
      {
        [group]: {
          ...this.state[group],
          [name]: e.target.value,
        },
      },
      () => this.validate(group, name),
    );
  };

  onChangeSelect = (e, group) => {
    const name = e.state;
    if (name === 'lawBasic' && e.value !== 'dziedziczenia na podstawie postanowienia Sądu') {
      this.setState(
        {
          [group]: {
            ...this.state[group],
            [name]: e.value,
            courtName: null,
            courtNr: null,
          },
        },
        () => this.validate(group, name),
      );
    }
    else {
      this.setState(
        {
          [group]: {
            ...this.state[group],
            [name]: e.value,
          },
        },
        () => this.validate(group, name),
      );
    }
  }

  validateField = (group, field) => {
    const checks = [];
    if (Object.keys(this.validators).indexOf(field) > -1) {
      for (const validator of this.validators[field]) {
        const check = validator(this.state[group][field]);
        if (check) checks.push(check);
      }
    }
    return checks;
  };

  validateGroup = group => {
    const fields = Object.keys(this.state[group]);
    const errors = {};
    for (const f of fields) {
      const checks = this.validateField(group, f);
      errors[f] = checks;
    }
    return errors;
  };

  validate = (group, field = null, callback = null) => {
    let newState = null;
    if (field) {
      if (Object.keys(this.validators).indexOf(field) > -1) {
        const checks = this.validateField(group, field);
        newState = {
          errors: {
            ...this.state.errors,
            [field]: checks,
          },
        };
      }
    } else if (group) {
      const errors = this.validateGroup(group);
      newState = { errors };
    } else {
      let errors = {};
      const grupy = ['info'];
      for (const g of grupy) {
        const err = this.validateGroup(g);
        errors = { ...errors, ...err };
      }
      newState = { errors: { ...errors } };
    }
    if (newState) {
      if (callback) {
        this.setState(newState, callback);
      } else {
        this.setState(newState);
      }
    }
  };

  haseErrors = () => {
    for (const key of Object.keys(this.state.errors)) {
      if (this.state.errors[key].length > 0) return true;
    }
    return false;
  };

  insertTestData = () => {
    this.setState({
      info: {
        parents: 'Jan, Janina',
        pesel: '123456789',
        town: 'Warszawa',
        decisionNumber: 'AAA1234',
        buildingNr: 'Nr test',
        percent: '55.00',
        buildingType: 'mieszkalnego',
        sellingDate: '01-01-2010',
        lawBasic: 'dziedziczenia na podstawie postanowienia Sądu',
        lawDate: '10-10-2010',
        courtName: 'Sąd testowy',
        courtNr: '1/123',
      },
    });
  };

  postValidation = () => {
    const hasFieldErrors = this.haseErrors();
    if (this.state.selectedParcels.length === 0) {
      this.setState({
        errorText: 'Nie wybrano działki ewidencyjnej. Prosimy o wskazanie działki',
        errorTitle: 'Błędnie wypełniony formularz',
        showError: true,
      });
      return;
    }

    if (hasFieldErrors) {
      this.setState({
        errorText: 'Uzupełnij pola obowiązkowe.',
        errorTitle: 'Błędnie wypełniony formularz.',
        showError: true,
      });
      return;
    }
    if (!hasFieldErrors) {
      this.props
        .runService(this.props.serviceInfo.eservice.shortName, this.props.district, {
          dzialki: this.state.selectedParcels,
          selectedParcels: this.state.selectedParcels,
          info: this.state.info,
          user: {
            ...this.props.serviceInfo.user,
          },
          shortName: this.props.serviceInfo.eservice.shortName,
          urzad: this.props.districts[this.props.prefix],
        })
        .then(resp => {
          window.location.href = `${this.nextStep}${resp.jobId}`;
        });
    }
  };

  startService = () => {
    this.validate(null, null, this.postValidation);
  };

  render() {
    return (
      <div style={{ paddingTop: '20px' }}>
        <h3 style={{ textAlign: 'center' }}>
          {this.props.serviceInfo.eservice.title}
        </h3>
        <PersonalDataContainer userData={this.props.serviceInfo.user ? this.props.serviceInfo.user : null} />
        <GrayPanel
          title={'1. Adres'}
        >
          <div className="help-desc">
            W celu wybrania przedmiotowej działki lub działek ewidencyjnych należy wykorzystać jeden
            z dwóch dostępnych sposobów wyboru działki:<br />
            <ol>
              <li>
                {' '}
                Wybrać obręb ewidencyjny z rozwijalnej listy obrębów, a następnie wpisać numer
                działki. W celu dodania kolejnej działki należy powtórzyć czynność.
              </li>
              <li>
                Wskazać działkę w oknie mapy wykorzystując przycisk{' '}
                <samp>"Wskaż działki na mapie"</samp>. W celu wybrania kilku działek konieczne jest
                przytrzymanie na klawiaturze klawisza <kbd>CTRL</kbd>.
              </li>
            </ol>
            Wybór działek można usunąć pojedynczo lub usuwając wszystkie za pomocą przycisku{' '}
            <samp>"Odznacz wszystko"</samp>.
          </div>
          <CustomizedMap
            serviceType={this.props.serviceInfo.eservice.shortName}
            setParcels={this.setParcels}
            setSelectDzialki={this.setSelectDzialki}
            selectedParcels={this.state.selectedParcels}
            obreby={this.props.serviceInfo.precints}
            district={this.props.districts[this.props.prefix]}
            prefix={this.props.prefix}
            mapState={this.props.mapstates[0]}
            settings={this.props.serviceInfo.eservice.mapConfig}
            dokumentType={this.props.serviceInfo.eservice}
          />
        </GrayPanel>
        <DecisionContainer
          title={'2. Informacje'}
          data={this.state.info}
          errors={this.state.errors}
          formDict={InfoTypeDict}
          onChange={e => this.onChange(e, 'info')}
          onChangeSelect={e => this.onChangeSelect(e, 'info')}
        />
        {this.state.info.lawBasic === 'dziedziczenia na podstawie postanowienia Sądu' ?
          <DecisionContainer
            title={'3. Informacje o dziedziczeniu'}
            data={this.state.info}
            errors={this.state.errors}
            formDict={courtTypeDict}
            onChange={e => this.onChange(e, 'info')}
          />
          : null}
        <ModalAlert
          title={this.state.errorTitle}
          bodyText={this.state.errorText}
          show={this.state.showError}
          name="errorModal"
          onHide={this.onHide}
        />

        {/* BUTTONS */}
        <div className="row mobile-row">
          <div className="col-sm-12">
            <PowrotDoListyEuslug position="left" prefix={this.props.prefix} />
            <EmptyFileDownloader position="left" prefix={this.props.prefix} serviceType={this.props.serviceInfo.eservice.shortName} />
            <button
              type="submit-lg"
              className={this.props.isDisabled ? 'btn btn-primary disabled' : 'btn btn-primary'}
              style={{ float: 'right', marginRight: '15px', ...btnStyle }}
              onClick={() => this.setState({ progress: 0 }, () => this.startService())}
            >
              Uruchom
            </button>
            {_.includes(this.props.serviceInfo.user.roles, 'superadmin') ? (
              <button
                type="submit-lg"
                className="btn btn-success"
                style={{ float: 'right', marginRight: '15px', ...btnStyle }}
                onClick={this.insertTestData}
              >
                Insert Test Data
              </button>
            ) : null}
            <button
              type="submit-lg"
              className="btn btn-default"
              style={{ float: 'right', marginRight: '15px', ...btnStyle }}
              onClick={history.goBack}
            >
              Anuluj
            </button>
          </div>
        </div>
      </div>
    );
  }
}

PrzeksztalceniePrawaUzytkowania.propTypes = {
  serviceInfo: PropTypes.object,
  district: PropTypes.string,
};

const mapState = state => ({
  current_service: state.eservices.current,
  districts: state.district.districts
});

const mapDispatch = {
  runService,
};

export default withStyles(pans)(
  connect(
    mapState,
    mapDispatch,
  )(PrzeksztalceniePrawaUzytkowania),
);



// WEBPACK FOOTER //
// src/routes/eservices/PrzeksztalceniePrawaUzytkowania.js